<div *ngIf="currentDna.dnaData">
  <app-dna-canvas [data]="currentDna"></app-dna-canvas>
</div>

